<template>
  <div>
    <b-row class="mx-0">
      <b-col>
        <h2>Reklamationsgründe</h2>
      </b-col>
      <b-col>
        <b-button size="md" @click="create()" class="float-right">
          <span class="icon icon-plus"></span>
        </b-button>
      </b-col>
    </b-row>
   <b-table class="mt-3" :items="reasons" :fields="fields" striped hover>
        <template v-slot:cell(reason)="data">
            <click-to-edit-component v-model="data.item.reason" :dataId="data.item.id" dataPath="/shipping_service_claim_reason/reason"/>

        </template>
        <template v-slot:cell(reasonDescription)="data">
            <click-to-edit-component v-model="data.item.reasonDescription" :dataId="data.item.id" dataPath="shipping_service_claim_reason/reason_description"/>
        </template>
        <template v-slot:cell(actions)="data">
            <b-button size="md" @click="deleteReason(data.item)" class="float-right">
                <span class="icon icon-bin"></span>
            </b-button>
        </template>
    </b-table>
       <b-modal
          v-model="modalEdit"
          size="md"
          centered
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          dismissible
          @ok="saveNewReason()"
        >
          <div class="modal-header">
            <h5 class="modal-title">Reklamationsgrund hinzufügen</h5>
          </div>
          <b-form-input
              list="blockReasons"
              size="md"
              placeholder="Grund"
              v-model="newReason.reason"
          ></b-form-input>
                    <b-form-input
              list="blockReasons"
              size="md"
              placeholder="Grundbeschreibung"
              v-model="newReason.reasonDescription"
          ></b-form-input>
        </b-modal>
  </div>
</template>
<script>
export default {
    data() {
        return {
            reasons: null,
            modalEdit: false,
            newReason: {
                reason: '',
                reasonDescription: '',
            },
            fields: 
            [
                { key: 'reason'           , label: 'Grund-kurz' },
                { key: 'reasonDescription', label: 'Grund-lang' },
                { key: 'actions'          , label: '' }
            ],
        }
    },
    methods: {
        create() {
            this.newReason.reason = '';
            this.newReason.reasonDescription = '';
            this.modalEdit = true;
        },
        saveNewReason() {
            axios.post('shipping_service_claim_reason', this.newReason)
            .then( response => {
                    console.log(response);
                axios.get('shipping_service_claim_reason/all').then( response => {
                    this.reasons = response.data;
            }).catch( error => {
                console.log("Netzwerkfehler.");
                console.error(error);
            });
            }).catch(error => {
            alert("Netzwerkfehler. Sperrgrund konnte nicht abgespeichert werden.");
            });
        },
        deleteReason(reason) {
            axios.delete('shipping_service_claim_reason/' + reason.id).then( response => {
                console.log(response);
                axios.get('shipping_service_claim_reason/all').then( response => {
                this.reasons = response.data;
                }).catch( error => {
                    console.log("Netzwerkfehler.");
                    console.error(error);
                });
            }).catch( error => {
            alert("Netzwerkfehler.");
            });

        },
    },
    watch: {

    },
    created() {
        axios.get('shipping_service_claim_reason/all').then( response => {
            this.reasons = response.data;
        }).catch( error => {
            console.log("Netzwerkfehler.");
            console.error(error);
        });
    },
    mounted() {

    }
}
</script>